import { Loading } from 'ui';
interface LoadingPlaceholderProps {
  height?: string;
  className?: string;
}
export default function LoadingPlaceholder({
  height = 'h-32',
  className = ''
}: LoadingPlaceholderProps) {
  return <div className={`${height} ${className} relative flex min-h-32 w-full items-start justify-center py-10`} aria-label='Loading content...' data-sentry-component="LoadingPlaceholder" data-sentry-source-file="LoadingPlaceholder.tsx">
      <Loading size='large' data-sentry-element="Loading" data-sentry-source-file="LoadingPlaceholder.tsx" />
    </div>;
}